export default __webpack_public_path__ + "static/media/swiper_3.420de864.png";